import {cn} from '@/lib/utils';
import {avertaRegular} from '@/styles/fonts';
import Link from 'next/link';
import {PropsWithChildren} from 'react';

type Props = PropsWithChildren & {
  path?: string;
};

export default function NavBreadcrumbItem({children, path}: Props) {
  return (
    <li className={cn('float-left', avertaRegular.className)}>
      {path ? (
        <Link href={path} className="hover:underline">
          {children}
        </Link>
      ) : (
        children
      )}
    </li>
  );
}
